import { useAuth } from '../contexts/AuthContext';
import {
  hasRole,
  hasPermission,
  isAdmin,
  isAdminOrManager,
  isAdminManagerOrReader,
  getRoleDisplayName,
  ROLES,
  isManagerRole,
  canVerify
} from '../utils/roleUtils';

export const useRole = () => {
  const { user } = useAuth();

  const roleId = user?.roleId;
  //const roleName = user?.roleName;

  return {
    // 基本角色信息
    roleId,
    //roleName,
    roleDisplayName: getRoleDisplayName(roleId),

    // 角色檢查
    isAdmin: isAdmin(roleId),
    isManager: roleId === ROLES.MANAGER,
    isReader: roleId === ROLES.READER,
    isStaff: roleId === ROLES.STAFF || !roleId,

    // 組合角色檢查
    isManagerRole: isManagerRole(roleId),
    isAdminOrManager: isAdminOrManager(roleId),
    isAdminManagerOrReader: isAdminManagerOrReader(roleId),
    canVerify: canVerify(roleId), // 核實權限（僅限 Admin 和 Manager）

    // 權限檢查方法
    hasRole: (requiredRole: string) => hasRole(roleId, requiredRole),
    hasPermission: (permission: string) => hasPermission(roleId, permission),

    // 角色權限檢查
    canCreateUser: hasRole(roleId, ROLES.ADMIN) || hasRole(roleId, ROLES.MANAGER),
    canEditUser: hasRole(roleId, ROLES.ADMIN) || hasRole(roleId, ROLES.MANAGER),
    canDeleteUser: hasRole(roleId, ROLES.ADMIN),
    canViewUser: hasRole(roleId, ROLES.ADMIN) || hasRole(roleId, ROLES.MANAGER) || hasRole(roleId, ROLES.STAFF),

    canCreateData: hasRole(roleId, ROLES.ADMIN) || hasRole(roleId, ROLES.MANAGER) || hasRole(roleId, ROLES.STAFF),
    canEditData: hasRole(roleId, ROLES.ADMIN) || hasRole(roleId, ROLES.MANAGER) || hasRole(roleId, ROLES.STAFF),
    canDeleteData: hasRole(roleId, ROLES.ADMIN),
    canViewData: true, // 所有角色都可以查看數據

    // 系統管理權限
    canAccessSystemAdmin: hasRole(roleId, ROLES.ADMIN),
  };
};
